import React from "react";
import { usePage, router } from "@inertiajs/react";
import { translations } from "../constants/translation";

const LandingLanguageContext = React.createContext(undefined);

export function LandingLanguageProvider({ children }) {
  const { locale } = usePage().props;
  const language = locale === "id" ? "id" : "en";
  const t = translations[language].landing;

  const switchLocale = (newLocale) => {
    const path = window.location.pathname;
    if (newLocale === "id") {
      const newPath = path.startsWith("/hebe") ? `/id${path}` : "/id/hebe";
      router.visit(newPath);
    } else {
      const newPath = path.startsWith("/id/hebe") ? path.replace("/id/hebe", "/hebe") : "/hebe";
      router.visit(newPath);
    }
  };

  const value = React.useMemo(
    () => ({ language, t, switchLocale }),
    [language, t]
  );

  return (
    <LandingLanguageContext.Provider value={value}>
      {children}
    </LandingLanguageContext.Provider>
  );
}

export function useLandingLanguage() {
  const ctx = React.use(LandingLanguageContext);
  if (ctx === undefined) {
    throw new Error("useLandingLanguage must be used within LandingLanguageProvider");
  }
  return ctx;
}
